import React from 'react';

var LogoFull = function LogoFull(_ref) {
  var inverted = _ref.inverted;
  return /*#__PURE__*/React.createElement("svg", {
    height: "30",
    viewBox: "0 0 348 80",
    width: "130",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: inverted ? '#fff' : '#000'
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.1 79.1c-5.3 0-9-1.6-9-1.6v-4.6s5.6 1.8 8.9 1.8c2.9 0 5.8-.5 5.8-4.1 0-2.7-2-3.3-4.5-4l-2.3-.6c-3-.9-8-2.1-8-8.2 0-6.8 5.5-8.5 11.2-8.5 5.1 0 8 1.7 8 1.7v4.5s-3.8-1.8-8.2-1.8c-3.6 0-5.9.7-5.9 3.8 0 2.7 2.1 3.3 4.6 4l2.8.8c3.3.9 7.5 2.8 7.5 8.2.1 6.8-4.9 8.6-10.9 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.4 79.1c-5.6 0-13.4-1.8-13.4-14.9 0-12.8 7.9-14.9 13.4-14.9 5.2 0 13.4 1.8 13.4 14.9 0 13.3-8.1 14.9-13.4 14.9zm0-25.8c-3 0-8 .9-8 10.9 0 10.1 5.8 10.8 8 10.8 2.7 0 8-1.1 8-10.8-.1-10.1-5.1-10.9-8-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.8 78.6v-38.2h5.4v38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92 78.6-.5-3.7s-3.3 4.3-9.4 4.3c-4.4 0-9.2-1.6-9.2-8.8 0-8 7.5-9.5 12.1-9.5h6.3v-2.5c0-3.7-2.2-4.6-6-4.6-4.6 0-10 2-10 2v-4.4s4.9-2 10.8-2c6.3 0 10.6 2.3 10.6 9.9v19.4h-4.7zm-.7-14.5-5.2.1c-4.9.1-7.9 1.4-7.9 6 0 3.7 2.3 4.8 5.2 4.8 4 0 7.9-3.7 7.9-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.3 54.2c-3.2 0-5.7 3.5-5.7 3.5v20.9h-5.4v-28.8h4.3l.7 4s1.8-4.5 6.7-4.5c2.8 0 3.9.8 3.9.8v4.9s-1.7-.8-4.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.6 78.6h-7.5l-4.5-15.3c-1.2-4.1-2.9-10.8-2.9-10.8s-1.8 6.8-3 10.7l-4.4 15.4h-7.5l-7.6-28.8h6.2l3.5 16.5c.8 3.8 1.7 9.8 1.7 9.8s1.1-6 2.3-9.8l4.9-16.5h7.8l4.9 16.5c1.1 3.7 2.3 9.8 2.3 9.8s.9-5.5 1.8-9.8l3.5-16.5h6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 78.6v-28.9h5.4v28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212 78.6v-19.7c0-3.6-1.5-4.9-5.2-4.9-4.8 0-9.5 3.6-9.5 3.6v21h-5.4v-28.8h4.2l1.1 4.1s4.8-4.6 10.9-4.6c5.3 0 9.3 2.3 9.3 9.7v19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.6 78.6-.6-3.6s-3 4.2-9.3 4.2c-4.5 0-11.9-2-11.9-14.9 0-13.1 9.2-14.9 13-14.9 5.2 0 7.6 2.9 7.6 2.9v-11.9h5.4v38.2zm-1.2-22.1s-3-2.9-7.1-2.9c-4 0-8.1 1.6-8.1 10.6 0 9.5 4.2 10.6 7.6 10.6 3.9 0 7.6-3.3 7.6-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.5 79.1c-5.3 0-9-1.6-9-1.6v-4.6s5.6 1.8 8.9 1.8c2.9 0 5.8-.5 5.8-4.1 0-2.7-2-3.3-4.5-4l-2.3-.6c-3-.9-8-2.1-8-8.2 0-6.8 5.5-8.5 11.2-8.5 5.1 0 8 1.7 8 1.7v4.5s-3.8-1.8-8.2-1.8c-3.6 0-5.9.7-5.9 3.8 0 2.7 2.1 3.3 4.6 4l2.8.8c3.3.9 7.5 2.8 7.5 8.2.1 6.8-4.8 8.6-10.9 8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f99d1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.8 32.3c.3-.1.5-.1.7-.2 5.5-1.6 10.8-3.7 16.2-5.9 5.2-2.2 10.3-4.8 14.9-8.5 4.6-3.8 8.3-8.7 10.4-14.7.3-.8.9-2.1.9-3-7.2 9.9-35.9 10.9-35.9 10.9l6.8-6.2c-27.2.1-46.2 11.6-54.9 17.8 11.1 1.2 21.2 5.9 29.1 13 3.9-1.2 7.9-2.1 11.8-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.7 31.3s-26.4-2-53.9 6.8c3.6 3.8 6.7 8.2 9.1 12.9 14.4-7.9 34.5-18.2 44.8-19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.7 55.2c1.7 4.3 2.8 8.9 3.3 13.7l25.2-25.9z"
  })));
};

export default LogoFull;